import { environment } from "@environments/environment";
import { BrowserOptions, browserTracingIntegration, replayIntegration } from "@sentry/angular";

export const SentryConfig: BrowserOptions = {
  environment: 'production',
  release: environment.version,
  dsn: environment.sentryDsn,
  ignoreErrors: [],
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['https://dashboard.calenso.com', 'https://my.calenso.com/api', 'https://auth.calenso.com/api'],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.8,
};
